<template>
  <b-modal id="modal-credit-debit"
           @hide="resetForm"
           @ok="handleOk()"
           title="BootstrapVue">
    <b-form-group label="Descripción">
      <b-input v-model="$v.detailForm.description.$model"
               :state="$v.detailForm.description.$dirty ? !$v.detailForm.description.$error : null"
      ></b-input>
    </b-form-group>
    <b-form-group label="Cantidad">
      <b-input v-model="$v.detailForm.quantity.$model"
               :state="$v.detailForm.quantity.$dirty ? !$v.detailForm.quantity.$error : null"
      ></b-input>
    </b-form-group>
    <b-form-group label="Precio">
      <b-input v-model="$v.detailForm.price.$model"
               :state="$v.detailForm.price.$dirty ? !$v.detailForm.price.$error : null"
      ></b-input>
    </b-form-group>
  </b-modal>
</template>

<script>
  import {required, decimal, maxLength} from 'vuelidate/lib/validators'

  export default {
    name: "DetailModal",
    data() {
      return {
        detailForm: {
          description: null,
          detail_type: null,
          quantity: null,
          price: null,
        },
      }
    },
    validations: {
      detailForm: {
        description: {required, maxLength: maxLength(50)},
        quantity: {required},
        price: {required},
      },
    },
    methods: {
      resetForm (){
        this.detailForm.description = null;
        this.detailForm.detail_type = null;
        this.detailForm.quantity = null;
        this.detailForm.price = null;
      },
      handleOk() {
        const item = {
          description: this.detailForm.description,
          detail_type: this.detailForm.detail_type,
          quantity: this.detailForm.quantity,
          price: this.detailForm.price,
        };
        this.$emit('ok', item);
        this.$nextTick(() => {
          this.$bvModal.hide(modal-credit-debit)
          this.$v.detailForm.$reset();
        })

      }
    }
  }
</script>

<style scoped>

</style>
